<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
  <div class="rounded-t border-b-2 mb-0 p-6">
      <h5 class="text-primary text-lg font-bold ">  پیام </h5>
  </div>

  <div class="flex-auto p-4">
      <div class="relative w-full overflow-x-auto rounded-md">
          <table class="w-full bg-transparent border-collapse">
            <thead class="bg-primary text-white">
              <tr>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold" >
                  پیام
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold" >
                  تاریخ
                </th>
                <th
                  class="align-middle border border-solid p-4 text-base uppercase border-l-0 border-r-0 font-semibold" >
                  وضعیت
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- <tr *ngIf="messagesList.length==0">
                <td class="p-4" colspan="3"> هیچ پیامی وجود ندارد </td>
              </tr> -->
              <!-- <ng-template *ngIf="messagesList.length!=0"> -->
              <tr class="border-b" *ngFor="let msg of messagesList">
                <a class="contents cursor-pointer" (click)="showMessage=msg;seeMessage(msg.id);modal.open()">
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-4">
                    {{msg.text | slice:0:10}} ...
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-4">
                    {{(msg.createAt|shamsiDate)}}
                  </td>
                  <td class="border-t-0 align-middle border-l-0 border-r-0 text-sm p-4">
                    <ng-container *ngFor="let item of messageStatus">
                      <span [ngClass]="msg.status==1?'text-red-700 text-sm font-medium px-3 py-1 rounded border border-red-700':'text-primary text-sm font-medium px-3 py-1 rounded border border-primary'"
                      *ngIf="msg.status==item.value"> {{item.title}} </span>
                    </ng-container>
                  </td>
                </a>
              </tr>
              <!-- </ng-template> -->
            </tbody>
          </table>
        </div>
  </div>
</div>
  



<!-- MODAL SECTION -->

<app-modal #modal>
<!--header-->
<div class="flex items-start justify-between p-2 border-b border-solid border-blueGray-200 rounded-t">
  <h5 class="text-lg font-semibold" *ngIf="showMessage">
     پیام {{showMessage.messageType==0?' گروهی':'خصوصی'}} پزشک
  </h5>
  <button class="p-1 bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none" (click)="modal.close()">
    <span class="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
      ×
    </span>
  </button>
</div>
<!--body-->
<div class="relative p-4 flex-auto">
  <p class="mt-4 mb-12 text-blueGray-500 text-lg text-start leading-relaxed" *ngIf="showMessage">
    {{showMessage.text}}
  </p>
</div>
<!--footer-->
<div class="flex items-center justify-end py-2 border-solid border-blueGray-200 rounded-b">
  <button class="text-red-500 border-red-500 background-transparent font-bold px-6 py-2 rounded text-sm my-2 ease-linear transition-all duration-150" type="button" (click)="modal.close()">
    بستن
  </button>
</div>
</app-modal>